import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import travelsReportAction from "~/actions/reporting/travelsReportAction";

import { Container, Grid } from "@material-ui/core";

import fleetAction from "~/actions/fleetAction";
import driverAction from "~/actions/driverAction";
import vehicleSearchAction from "~/actions/vehicleSearchAction";

import Page from "~/components/common/page/Page";
import ReportTravels from "~/components/reporting/travels/ReportTravels";

import OptionExportButton from "~/components/common/exportButton/OptionExportButton";

import _ from "lodash";

const Reporting = () => {
    const dispatch = useDispatch();

    const { value } = useSelector((state) => state.reportTab);
    const { loading } = useSelector((state) => state.app);

    useEffect(() => {
        let filter = {
            type: "gps",
            functionality: "3",
        };
        dispatch(fleetAction.fleetData(filter));
        dispatch(driverAction.driverData({ amount: -1 }));
        dispatch(vehicleSearchAction.vehicleData(filter));
    }, [dispatch]);

    const {
        perObject: { filters },
    } = useSelector((state) => state.travelsReport);

    return (
        <>
            <Page
                topButtons={
                    value === "TAB_OBJECT" ? (
                        <div id="export-container">
                            <OptionExportButton
                                loading={loading.requestObjectDoc}
                                onClick={(type) => {
                                    if (_.isEmpty(filters.period)) {
                                        return;
                                    }

                                    const format = type.value.toLowerCase();
                                    dispatch(
                                        travelsReportAction.requestPerObject(
                                            {
                                                ...filters,
                                                format: format === "xlsx" ? "xls" : format,
                                            },
                                            () => {},
                                            "requestObjectDoc"
                                        )
                                    );
                                }}
                            />
                        </div>
                    ) : null
                }>
                <Container maxWidth="lg" className="container-map-view">
                    <Grid container>
                        <Grid item xs={12}>
                            <ReportTravels />
                        </Grid>
                    </Grid>
                </Container>
            </Page>
        </>
    );
};

export default Reporting;
